import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

const REQUEST_ID_HEADER = 'x-request-id';

export interface Kcc20Notification {
  messageId: string;
  eventId?: string;
  type: string;
  status: string;
  title?: string;
  message: string;
  entityId?: string;
  timestamp: number;
  customPayload?: Record<string, unknown>;
}

export interface Kcc20NotificationsPage {
  items: Kcc20Notification[];
  total: number;
  unreadTotal?: number;
  unreadCount?: number;
  limit: number;
  offset: number;
}

@Injectable({ providedIn: 'root' })
export class Kcc20NotificationsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getMine(
    query: { limit?: number; offset?: number } = {},
    requestId?: string,
  ): Observable<Kcc20NotificationsPage> {
    let params = new HttpParams();
    if (query.limit !== undefined) params = params.set('limit', query.limit);
    if (query.offset !== undefined) params = params.set('offset', query.offset);
    return this.http.get<Kcc20NotificationsPage>(
      `${this.baseUrl}/notifications`,
      this.options(requestId, params),
    );
  }

  markMineRead(messageId: string, requestId?: string): Observable<void> {
    return this.http.patch<void>(
      `${this.baseUrl}/notifications/mark-read/${messageId}`,
      {},
      this.options(requestId),
    );
  }

  markMineAllRead(requestId?: string): Observable<void> {
    return this.http.patch<void>(
      `${this.baseUrl}/notifications/mark-all-read`,
      {},
      this.options(requestId),
    );
  }

  clearMine(requestId?: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/notifications`,
      this.options(requestId),
    );
  }

  private options(requestId?: string, params?: HttpParams) {
    return {
      withCredentials: true,
      ...(params ? { params } : {}),
      ...headers(requestId),
    };
  }
}

function headers(requestId?: string) {
  return requestId
    ? {
        headers: {
          [REQUEST_ID_HEADER]: requestId,
        },
      }
    : {};
}
